module.exports = __webpack_public_path__ + "img/welcomeLogo.8699a6ff.png";